<bb-page-header [icon]="'key'" [title]="'UPLOAD_CREDENTIALS' | translate"></bb-page-header>

<div class="body-column">
	<div class="action-buttons">
		<a class="button" [routerLink]="['/publication/upload-credentials/new']"><i class="fa fa-plus"></i>
			<span class="short-label">{{ 'NEW_KEY' | translate }}</span>
			<span class="long-label">{{ 'CREATE_NEW_KEY' | translate }}</span>
		</a>
	</div>

	<bb-table-container>
		<bb-table-header>
			<bb-table-header-cell property="id" optional>{{ 'ID' | translate }}</bb-table-header-cell>
			<bb-table-header-cell property="label">{{ 'LABEL' | translate }}</bb-table-header-cell>
			<bb-table-header-cell property="status">&nbsp;</bb-table-header-cell>
			<bb-table-header-cell property="createddate">{{ 'CREATED' | translate }}</bb-table-header-cell>
			<bb-table-header-cell optional property="createdBy">{{ 'CREATED_BY' | translate }}</bb-table-header-cell>
			<bb-table-header-cell property="updateddate">{{ 'UPDATED' | translate }}</bb-table-header-cell>
			<bb-table-header-cell optional property="updatedBy">{{ 'UPDATED_BY' | translate }}</bb-table-header-cell>
			<bb-table-header-cell class="row-actions buttons"></bb-table-header-cell>
		</bb-table-header>

		<bb-table-row *ngFor="let row of rows" [row]="row">
			<bb-table-cell property="id">{{ row.data.id }}</bb-table-cell>
			<bb-table-cell property="label" class="overflow">{{ row.data.label }}</bb-table-cell>
			<bb-table-cell property="status"><div [innerHtml]="row.data | statusIcon"></div></bb-table-cell>
			<bb-table-cell property="createddate" class="date" [titleValue]="row.data.createddate | bbDate">{{ row.data.createddate | bbDate:'relative' }}</bb-table-cell>
			<bb-table-cell optional property="createdBy" [titleValue]="row.data.createdBy">{{ row.data.createdBy }}</bb-table-cell>
			<bb-table-cell property="updateddate" class="date" [titleValue]="row.data.updateddate | bbDate">{{ row.data.updateddate | bbDate:'relative' }}</bb-table-cell>
			<bb-table-cell optional property="updatedBy" [titleValue]="row.data.updatedBy">{{ row.data.updatedBy }}</bb-table-cell>
			<bb-table-cell class="buttons row-actions" (click)="$event.stopPropagation()"><!-- stopPropagation so the row doesn't get selected -->
				<a class="button" [routerLink]="['/publication/upload-credentials/', row.data.id]">
					<i class="fa fa-edit"></i>
				</a><!--
				--><a class="button" [ngClass]="{disabled: !putRight}" (click)="deleteSingle(row.data)">
					<i class="fa fa-trash"></i>
				</a><!--
			--></bb-table-cell>
		</bb-table-row>
	</bb-table-container>
	<div class="no-results" *ngIf="rows && !rows.length">{{ 'NO_RESULTS_FOUND' | translate }}</div>
	<bb-table-pager></bb-table-pager>
</div>
